import { FC } from 'react';

const SupportPage: FC = () => {
  const supportEmail = 'support@thehonors.co.za';
  const subject = 'Golfers Honours Support Request';
  const mailtoLink = `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}`;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 bg-gray-50">
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary-100 mb-4">
            Golfers Honours Support
          </h1>
          <p className="text-lg text-gray-600">
            We are here to help with any questions or issues you may have.
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-3">
              Need Assistance?
            </h2>
            <p className="text-gray-600 mb-4">
              If you have questions, feedback, or need help with Golfers Honours
              app, please do not hesitate to reach out to our support team.
            </p>
          </div>

          <div className="flex flex-col items-center space-y-4">
            <a
              href={mailtoLink}
              className="inline-flex justify-center items-center px-8 py-3 text-lg font-semibold text-white bg-primary-100 hover:bg-primary-200 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              Contact Support via Email
            </a>
            <p className="text-sm text-gray-500">
              Email:{' '}
              <span className="font-medium text-gray-700">{supportEmail}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
